export const SUBMODULE_DISPLAY_NAMES = new Map([
    ["task", "Activity Log"],
    ["ratinggroup", "Rating Group"],
    ["midsessioncdr", "Mid Session Configuration"],
    // add more mappings here
]);

 export function formatSubmoduleName(value) {
    if (!value) return "";
    return SUBMODULE_DISPLAY_NAMES.get(value) || camelCaseToTitle(value);
}

export function camelCaseToTitle(str) {
    if (!str) return "";
    const result = str.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
}